import React from "react";
import { bind } from "decko";

export default class GridOptionSelector extends React.Component {
    constructor (props) {
        super(props);

        this.hotkeys = {
            "comma": this.selectLeft,
            "period": this.selectRight,
            "tab": this.selectRight,
            "s+tab": this.selectLeft,
        };
    }

    componentDidMount () {
        if (this.props.hotkeyHandler) {
            this.props.hotkeyHandler.subscribe(this.hotkeys, this);
        }
    }

    componentWillUnmount () {
        if (this.props.hotkeyHandler) {
            this.props.hotkeyHandler.unsubscribe(this.hotkeys, this);
        }
    }

    @bind
    selectRight () {
        let idx = Math.max(0,this.props.options.indexOf(this.props.selected));
        if (idx < this.props.options.length-1) idx++;
        else idx = 0;
        this.props.onSelectOption(this.props.options[idx]);
    }

    @bind
    selectLeft () {
        let idx = Math.max(0,this.props.options.indexOf(this.props.selected));
        if (idx === 0) idx = this.props.options.length - 1;
        else idx--;
        this.props.onSelectOption(this.props.options[idx]);
    }

    render () {
        const columns  = this.props.columns || 99;
        const options  = this.props.options;
        const onSelect  = this.props.onSelectOption;
        const selected = this.props.selected;

        let tableElements = options.map((option) => {
            let className = "table-options-item";
            if (option === selected) {
                className += " active";
            }
            return (
                <td key={option}>
                    <div className={className}
                        onClick={() => onSelect(option)}>
                        {option}
                    </div>
                </td>
            )
        });

        let tableRows = [];
        for (let i=0; i<tableElements.length; i+=columns) {
            tableRows.push(
                <tr key={i}>
                    {tableElements.slice(i, i+columns)}
                </tr>
            );
        }

        return (
            <table className="table table-options-container text-capitalize text-center">
                <tbody>
                    {tableRows}
                </tbody>
            </table>
        );
    }
}




// WEBPACK FOOTER //
// ./src/js/GridOptionSelector.js